<template>
  <div class="sandbox-wrapper" :style="cssProps">
    <iframe ref="sandbox" :src="previewSource" :style="cssProps"></iframe>
  </div>
</template>
<script>
import Vue from 'vue'

export default {
  props: {
    mediumId: Number,
    width: {
      type: Number,
      default: 1920
    },
    height: {
      type: Number,
      default: 1080
    },
    scale: {
      type: Number,
      default: 0.5
    },
    tokenParam: {
      type: String,
      default: null
    }
  },
  components: {
  },
  mixins: [],
  async created () {
    this.token = this.tokenParam ? this.tokenParam : this.$route.params.token
    await this.loadData()
  },
  mounted () {
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy () {
    window.removeEventListener('message', this.handleMessage)
    this.medium = undefined
  },
  data () {
    return {
      error: undefined,
      token: undefined,
      playlist: undefined,
      medium: undefined,
      previewSource: undefined,
      sandboxOrigin: undefined
    }
  },
  methods: {
    async loadData () {
      let response
      try {
        response = (await Vue.axios.post(`medium/preparePlaylistPreview`, { token: this.token, mediumId: this.mediumId })).data
      } catch (error) {
        this.error = error.response.data
      }
      this.previewSource = response.previewSourcePath
      this.playlist = response.playlist
      this.medium = response.medium
      this.medium.PlayItems = this.playlist
      this.sandboxOrigin = new URL(this.previewSource, location.href).origin
    },
    mediumSrc () {
      if (!this.medium) return false
      console.log(this.medium)
      return this.medium.filename
    },
    handleMessage (event) {
      if (event.source !== this.$refs.sandbox.contentWindow) {
        console.debug('ignoring message, based on source:', event)
        return
      }

      if (event.origin !== this.sandboxOrigin && event.origin !== 'null') {
        console.info('message() ignored:', event)
        return
      }

      console.info('sandbox message()', event)

      if (event.data.type === 'ready') {
        event.source.postMessage({ type: 'sandboxInit', data: [this.medium, 1000, { instrumentedMediaTypes: [] }] }, event.origin === 'null' ? '*' : this.sandboxOrigin)
        this.$emit('playerReady')
      }
    }
  },
  computed: {
    cssProps () {
      return {
        '--width': `${this.width}px`,
        '--height': `${this.height}px`,
        '--scale': `${this.scale}`
      }
    }
  },
  watch: {}
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.container-player {
  display: flex;
  flex-direction: column;
  // align-content: center;
  // align-items: center;
  justify-content: center;
  // justify-items: center;
  // width: 100%;
  .player {
    width: 90%;
    margin: 0 auto;
  }
}
iframe {
  border: 0;
  width: var(--width);
  height: var(--height);
  transform: scale(var(--scale));
  transform-origin: 0 0;

  background: black;

  display: flex;
  flex-direction: column;
  justify-content: center;
  /* background: repeating-conic-gradient(#aaa 0% 25%, #eee 0% 50%) 0% 0% / 50px 50px; */
}

.sandbox-wrapper {
  border: 1px solid $--color-warning;
  width: calc(var(--width) * var(--scale));
  height: calc(var(--height) * var(--scale));
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/FreePlayListPreview.vue